import styles from './form-control-label.module.scss';
import MaterialFormControlLabel from '@mui/material/FormControlLabel';

/* eslint-disable-next-line */
export interface FormControlLabelProps {
  control: any,
  label: any | number | string,
  checked?: boolean,
  // classes?: object,
  // componentsProps?: object,
  // disabled?: boolean,
  // disableTypography?: boolean,
  // inputRef?: any,
  // labelPlacement?:'bottom'| 'end'| 'start'| 'top',
  // onChange: (event: any) => void,
  // sx?: any,
  value?: any,
  // className?: string
}

export function FormControlLabel(props: FormControlLabelProps) {
  return (
    <MaterialFormControlLabel
      control={props.control}
      label={props.label}
      value={props.value}
    />
  );
}

export default FormControlLabel;